module.exports = __webpack_public_path__ + "static/img/benefit_mb1.8b02226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/benefit_mb1.png
// module id = o2kj
// module chunks = 30